<template>
	<b-container fluid class="px-1">    
	    <b-row class="justify-content-center mx-0">
	      <h1 style="text-align: center;">Privacy Policy</h1>
	    </b-row>
      <b-row class="justify-content-center mx-0">
        <p style="padding-left: 10%; padding-right: 10%;">

        Privacy Policy<br><br>

        Your privacy is very important to us. Accordingly, we have developed this policy in order for you to understand how we collect, use, communicate and disclose and make use of personal information. The following outlines our privacy policy.<br><br>

        Before or at the time of collecting personal information, we will identify the purposes for which information is being collected.<br><br>

        We will collect and use of personal information solely with the objective of fulfilling those purposes specified by us and for other compatible purposes, unless we obtain the consent of the individual concerned or as required by law.<br><br>

        We will only retain personal information as long as necessary for the fulfillment of those purposes.<br><br>

        We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the individual concerned.<br><br>

        Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date.<br><br>

        We will protect personal information by reasonable security safeguards against loss or theft, as well as unauthorized access, disclosure, copying, use or modification.<br><br>

        We will make readily available to customers information about our policies and practices relating to the management of personal information.<br><br>

        We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of personal information is protected and maintained.<br><br>
        </p>
        </b-row>
	</b-container> 
</template>

<script>
export default {
 
  data() {
    return {
      visible: false
    };
  },

  methods:{
 
  },

  components: { 
  },

  computed: {
  }
};
</script>
<style scoped>


</style>